import { defineStore } from "pinia";
import { Ref } from "vue";
import { providerService } from "@/features/provider/provider.service";
import { useNotification } from "@/utils/notification";
import { ITableHeader } from "@/types/table";
import { INewProvider, IUpdateProvider } from "./provider.types";

const { pushNotification } = useNotification();

export const useProviderStore = defineStore("provider", () => {
  const providerHeaders: ITableHeader[] = [
    {
      name: "id",
      label: "No",
      width: "3%",
    },
    {
      name: "name",
      label: "Name",
      width: "25%",
    },
    {
      name: "token",
      label: "App token",
      width: "40%",
    },
    {
      name: "status",
      label: "Status",
      width: "25%",
    },
    {
      name: "actions",
      label: "Actions",
      width: "7%",
    },
  ];

  async function getList(loading: Ref<boolean>, cl: any) {
    loading.value = true;

    await providerService
      .getList()
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  async function updateProvider(
    payload: IUpdateProvider,
    id: string,
    loading: Ref<boolean>,
    cl: any
  ) {
    loading.value = true;

    await providerService
      .updateProvider(payload, id)
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  async function createProvider(
    payload: INewProvider,
    loading: Ref<boolean>,
    cl: any
  ) {
    loading.value = true;

    await providerService
      .createProvider(payload)
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  return {
    providerHeaders,
    getList,
    updateProvider,
    createProvider,
  };
});
